import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserModel } from '@rillion/auth/models';
import { RoleAggregate } from '../../../libs/role';
import { LicenceModel } from '../../../libs/system';
import { HttpErrorResponse } from '@angular/common/http';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    'Get User': emptyProps(),
    'Get User Success': props<{ user: UserModel }>(),
    'Get User Failure': props<{ error: HttpErrorResponse }>(),

    'Get Roles': emptyProps(),
    'Get Roles Success': props<{ roles: string[] }>(),
    'Get Roles Failure': props<{ error: HttpErrorResponse }>(),

    'Get Licences': emptyProps(),
    'Get Licences Success': props<{ licences: LicenceModel[] }>(),
    'Get Licences Failure': props<{ error: HttpErrorResponse }>(),

    'Get Permissions': emptyProps(),
    'Get Permissions Success': props<{ permissions: RoleAggregate[] }>(),
    'Get Permissions Failure': props<{ error: HttpErrorResponse }>(),

    'Remove User': emptyProps(),
    'Set User Role': props<{ role: string }>(),
    'Update User Role': props<{ user: UserModel }>(),
  },
});
